import React from "react";
import { CardContent } from "@/components/ui/card";
import { PlanForm } from "./PlanForm";
import type { Plan, PlanFormData } from "@/types/plan";

interface PlansFormWrapperProps {
  onSubmit: (data: PlanFormData) => void;
  selectedPlan?: Plan;
  onClear: () => void;
  isEditing: boolean;
}

export const PlansFormWrapper = ({
  onSubmit,
  selectedPlan,
  onClear,
  isEditing,
}: PlansFormWrapperProps) => {
  return (
    <CardContent>
      <PlanForm
        onSubmit={onSubmit}
        initialData={selectedPlan}
        onClear={onClear}
        isEditing={isEditing}
      />
    </CardContent>
  );
};